const getters = {
  size: state => state.app.size,
  sidebar: state => state.app.sidebar,
  menuList: state => state.app.menuList,
  device: state => state.app.device,
  navTitle: state => state.app.navTitle,
  token: state => state.user.token,
  loginUserRoleName: state => state.user.loginUserRoleName,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  user: state => state.user.user,
  userId: state => state.user.userId,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  sidebarRouters: state => state.permission.sidebarRouters,
  toggleSearch: state => state.settings.toggleSearch,
  theme: state => state.settings.theme
}
export default getters
